import { isValid, parseISO } from 'date-fns';
import { isString } from 'lodash';

const getYYYYMMDD = (val: string) => {
  if (/(\d{4})-(\d{2})-(\d{2})/.exec(val)) {
    return val;
  }

  if (/(\d{2})\/(\d{2})\/(\d{4})/.exec(val)) {
    return `${val.slice(6, 10)}-${val.slice(0, 2)}-${val.slice(3, 5)}`;
  }

  return '';
};

const valueMissingTimeZone = (val: string | Date | null): val is string =>
  Boolean(
    isString(val) &&
      (/(\d{4})-(\d{2})-(\d{2})/.exec(val) ??
        /(\d{2})\/(\d{2})\/(\d{4})/.exec(val)),
  );

export const formatDate = (val: string | Date | null): Date | null => {
  if (val === null || val === undefined) {
    return null;
  }

  if (
    (isString(val) && val !== '' && isValid(parseISO(val))) ||
    isValid(new Date(val)) ||
    isValid(val)
  ) {
    if (valueMissingTimeZone(val)) {
      // MUI messes with the value if we don't add time
      const formattedDate = getYYYYMMDD(val);
      return new Date(`${formattedDate}T00:00:00`);
    }

    return new Date(val);
  }

  return null;
};
